import React from 'react';
import { IconButton, Typography, useSnackbar } from 'fronton-react';
import { CopySimpleIcon } from '@fronton/icons-react';
import { SNACKS } from 'common/components/snack/snacks';
import { EridWrapper } from './styles';
import { IconButtonVariant } from 'fronton-react/button/icon-button/types';

type EridTokenCopingProps = {
  eridToken: string;
  variant?: IconButtonVariant;
};

export const EridTokenCoping = ({ eridToken, variant = 'invert' }: EridTokenCopingProps) => {
  const { addSnack } = useSnackbar();

  const handleCopyClick = () => {
    window.navigator.clipboard.writeText(eridToken);

    addSnack({
      id: `${eridToken}`,
      ...SNACKS.SUCCESS_TOKEN_COPY,
    });
  };

  return (
    <div className={EridWrapper}>
      <IconButton label="Скопировать erid" variant={variant} onClick={handleCopyClick}>
        <CopySimpleIcon />
      </IconButton>
      <Typography variant="s" size="body_long">
        erid: {eridToken}
      </Typography>
    </div>
  );
};
